import { ChangeDetectorRef, Component, OnInit, SecurityContext, inject, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TitleCasePipe } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateDirective } from '@ngx-translate/core';
import { DividerComponent } from '../../../components/panel/divider.component';
import { ButtonComponent } from '../../../components/button/button.component';
import { IconComponent } from '../../../components/icon/icon.component';
import { PageActionPanelComponent } from '../../../features/page/page-action-panel.component';
import { HrefDirective } from '../../../directives/href/href.directive';
import { CheckboxComponent } from '../../../components/checkbox/checkbox.component';
import { TranslatePipe } from '../../../pipes/translate.pipe';

import { W8BenFormSuccessMessageComponent } from '../w8ben-form-success-message/w8ben-form-success-message.component';
import { W8BenFormService } from '../w8ben-form.service';
import { W8BenFormErrorComponent } from '../w8ben-form-error/w8ben-form-error.component';
import { W8BenFormAnalyticsService } from '../w8ben-form-analytics.service';
import { W8BenModalName } from '../w8ben-form.domain';
import { W8benFormAnalytics } from '../w8ben-form.analytics';

@Component({
  selector: 'td-wb-w8ben-review',
  templateUrl: 'w8ben-form-review.component.html',
  styleUrls: ['w8ben-form-review.component.scss'],
  imports: [
    CheckboxComponent,
    FormsModule,
    DividerComponent,
    PageActionPanelComponent,
    ButtonComponent,
    HrefDirective,
    W8BenFormSuccessMessageComponent,
    TranslatePipe,
    TranslateDirective,
    IconComponent,
    W8BenFormErrorComponent
  ],
  providers: [TitleCasePipe]
})

export class W8benFormReviewComponent implements OnInit {
  private readonly w8benFormService = inject(W8BenFormService);
  private readonly w8benFormAnalyticsService = inject(W8BenFormAnalyticsService);
  private readonly sanitizer = inject(DomSanitizer);
  private readonly titleCasePipe = inject(TitleCasePipe);
  private readonly changeDetectionRef = inject(ChangeDetectorRef);

  protected updateConfirmed: boolean = false;
  protected w8benFormBase64: SafeResourceUrl;
  protected certified: boolean = false;
  protected submitError: boolean = false;

  readonly hasUpdates = input<boolean>(false);

  constructor() {
    const pdfUrl = this.sanitizer.sanitize(SecurityContext.URL,
      `data:application/pdf;base64,${this.w8benFormService.formBase64}`) ?? '';

    this.w8benFormBase64 = this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);
  }

  ngOnInit(): void {
    this.setAnalytics(true);
  }

  protected getModalId(): string {
    return this.w8benFormAnalyticsService.getModalId();
  }

  protected onClickConfirm(): void {
    this.submitError = false;
    this.w8benFormService.confirmUpdatedProfile()?.subscribe({
      next: () => {
        this.setAnalytics();
        this.updateConfirmed = true;
        this.changeDetectionRef.markForCheck();
      },
      error: (): void => {
        this.submitError = true;
        this.changeDetectionRef.markForCheck();
      },
      complete(): void {
      }
    });
  }

  protected getFileName(): string {
    const profile = this.w8benFormService.profile;
    return `W-8BEN_${this.getTitleCase(profile.givenName)}${this.getTitleCase(profile.middleName)}${this.getTitleCase(profile.familyName)}.pdf`;
  }

  protected onClickDownload():void {
    this.w8benFormAnalyticsService.emitLinkClickEvent('w8ben:success:download', false);
  }

  private getTitleCase(value: string | undefined): string {
    return value ? this.titleCasePipe.transform(value).replace(/\s/g, '') : '';
  }

  private setAnalytics(review: boolean = false): void {
    const flow = this.hasUpdates() ? 'c' : 'a';
    if (review) {
      this.w8benFormAnalyticsService.setTaggingData(W8BenModalName.REVIEW, flow);
      this.w8benFormAnalyticsService.emitPageChange(W8benFormAnalytics.getModalEvent(W8BenModalName.REVIEW, flow));
    } else {
      this.w8benFormAnalyticsService.setTaggingData(W8BenModalName.SUCCESS, flow);
      this.w8benFormAnalyticsService.emitPageChange(W8benFormAnalytics.getModalEvent(W8BenModalName.SUCCESS, flow, 'complete'));
    }
  }
}

